import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { onSnapshot, getSnapshot } from 'mobx-state-tree';
import { range, inRange } from 'lodash';

import Container from './Container';
import RangeInput from './RangeInput';

const defaultLimit = { start: { hour: 0, minute: 0 }, end: { hour: 24, minute: 0 } };

@observer
export default class TimeInput extends Component {
  hourRange = range(1, 13);
  minuteRange = range(0, 60);
  periodRange = ['AM', 'PM'];
  minuteStep = this.props.minuteStep || 10;

  componentDidMount() {
    let period = this.props.time.period;
    let hour = this.props.time.hour;
    let minute = this.minuteRange.reduce((nearestMinute, rangeMinute) => {
      if (!nearestMinute && rangeMinute >= this.props.time.minute && !(rangeMinute % this.minuteStep)) {
        return rangeMinute;
      }
      return nearestMinute;
    }, null);

    if (minute === null) {
      minute = 0;
      hour++;
      if (hour > 12) {
        hour = hour % 12;
        period = period === 'AM' ? 'PM' : 'AM';
      }
    }

    this.props.time.setTime({
      minute,
      hour,
      period,
    });

    this.clampTimeToLimit(getSnapshot(this.props.time));
    this.timeClampListener = onSnapshot(this.props.time, this.clampTimeToLimit);
  }

  componentWillUnmount() {
    this.timeClampListener();
  }

  clampTimeToLimit = snapshot => {
    const limit = this.props.limit || defaultLimit;

    const snapShotTime = parseInt(
      `${(snapshot.period === 'AM' ? snapshot.hour : snapshot.hour + 12)
        .toString()
        .padStart(2, '0')}${snapshot.minute.toString().padStart(2, '0')}`,
    );

    const startLimit = parseInt(
      `${limit.start.hour.toString().padStart(2, '0')}${limit.start.minute.toString().padStart(2, '0')}`,
    );

    const endLimit = parseInt(
      `${limit.end.hour.toString().padStart(2, '0')}${limit.end.minute.toString().padStart(2, '0')}`,
    );

    if (!inRange(snapShotTime, startLimit, endLimit)) {
      let setTime;
      if (snapShotTime < startLimit) {
        setTime = limit.start;
      } else {
        setTime = limit.end;
      }

      let { hour, minute } = setTime;
      let period = 'AM';
      if (hour > 12) {
        hour = hour % 12;
        period = 'PM';
      }

      this.props.time.setTime({
        hour,
        minute,
        period,
      });
    }
  };

  render() {
    const time = this.props.time;
    return (
      <Container className={this.props.className}>
        <RangeInput
          range={this.hourRange}
          value={time.hour}
          limit={this.props.limit}
          onChange={time.setHour}
          wrapAround
        />
        <RangeInput
          step={this.minuteStep}
          range={this.minuteRange}
          values={value => value.toString().padStart(2, '0')}
          value={time.minute}
          onChange={time.setMinute}
          wrapAround
        />
        <RangeInput range={this.periodRange} value={time.period} onChange={time.setPeriod} wrapAround />
      </Container>
    );
  }
}
